import { render } from "./HealthyFood.vue?vue&type=template&id=4bd2c252&scoped=true"
import script from "./HealthyFood.vue?vue&type=script&lang=js"
export * from "./HealthyFood.vue?vue&type=script&lang=js"

import "./HealthyFood.vue?vue&type=style&index=0&id=4bd2c252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd2c252"]])

export default __exports__